module.exports = __webpack_public_path__ + "static/img/ML04.1acdca9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/ML04.jpg
// module id = eavs
// module chunks = 9